jQuery(function ($) {
    $(document).ready(function () {
        if ($(".dermo-protocol-swiper").length > 0) {
            initSwiper();
        }

        function initSwiper() {
            if ($(".dermo-protocol-swiper").hasClass('swiper-initialized')) {
                return;
            }

            const swiper = new Swiper(".dermo-protocol-swiper", {
                slidesPerView: 'auto',
                allowTouchMove: true,
                watchSlidesProgress: true,
            });
        }
    });
});
